import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CognosResponse } from '../Models/Cognos';
import { DynamicFieldRequest } from '../Models/FieldEntry';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CognosService {

  private readonly apiUrl = environment.apiUrl; // from environment file
  //private readonly apiUrl = 'http://localhost:7028/api'; /*For Localhost environment debug*/
  constructor(private readonly http: HttpClient, private readonly authService: AuthService) { }

  /* Fetch Cognos files based on dynamic search filters 
  * Flow:
  * Acquire Azure AD access token silently
  * Attach Bearer token to Authorization header
  * Attach Azure Function key (if required)
  * Call Azure Function API (POST)
  */
  getCognosFiles(model: DynamicFieldRequest): Observable<CognosResponse> {
    return this.http.post<CognosResponse>(
      `${this.apiUrl}/searchfiles`,
      model
    );
  }

  // Download file
  downloadFile(fileName: string): Observable<Blob> {
    return this.http.get(
      `${this.apiUrl}/files?fileName=${fileName}`,
      { responseType: 'blob' }
    );
  }
}
